import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getArchive, updateArchive } from "../../../api/homepageManagementStudyArchive.api";
import ErrorResponse from "../../../components/ErrorResponse";
import ArchiveEditor from "../../../components/homepage/archive/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetArchive } from "../../../models/homepageManagementStudyArchive.model";

interface IMatch {
  archiveCode: string;
}

const ArchiveEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const archiveCode = Number(match.params.archiveCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetArchive>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (archiveCode) {
      execute(getArchive(archiveCode));
    }
  }, [archiveCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/homepage/archive${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!archiveCode) return;
    submitExecute(updateArchive(archiveCode, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.archive.title4')}
      />
      <ArchiveEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default ArchiveEdit;
